import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'kkd-secim-yardimcisi',
  href: '/araclar/kkd-secim-yardimcisi',
  title: 'Kişisel Koruyucu Donanım Seçim Yardımcısı',
  shortLabel: 'Kişisel Koruyucu Donanım',
  eyebrow: 'KKD Yönetmeliği · EN/ISO standartlar',
  description:
    'Çalışma ortamındaki riskleri (darbe, kimyasal, düşme, ısı, gürültü…) seçin — uygun kişisel koruyucu donanım ve standart önerileri kategori bazında listelensin, PDF raporu oluşsun.',
  bullets: [
    '58 risk kriteri, 3 grup (Risk Tipi / Yapılan İş / Ortam Koşulu)',
    'CE/EN/ISO standart eşleştirmesi',
    'Firma + tarih + ek not alanı',
    'PDF rapor (analiz çıktısı, görüntüle / indir)',
  ],
  audience: 'İş güvenliği uzmanı · Şantiye yöneticisi · Üretim sorumlusu',
  icon: ShieldCheckIcon,
  mevzuat: [
    { no: '28695', ad: 'Kişisel Koruyucu Donanımların İşyerlerinde Kullanılması Hakkında Yönetmelik (RG 02.07.2013)' },
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu', madde: 'Md 4, 17' },
  ],
  imzaTipi: 'YOK',
  raporlama: 'PDF',
  pdfEndpoint: '/api/kkd/pdf',
  faqs: [
    {
      question: 'KKD nedir?',
      answer:
        'KKD (Kişisel Koruyucu Donanım), çalışanı işyerindeki bir veya birden fazla risk faktöründen koruyan; çalışan tarafından giyilen, takılan veya tutulan donanımdır. KKD Yönetmeliği ve 6331 sayılı İSG Kanunu, riskin önce kaynağında giderilmesini zorunlu kılar; tam giderilemiyorsa son savunma hattı olarak KKD kullanılır.',
    },
    {
      question: 'KKD seçimi yasal olarak nasıl yapılır?',
      answer:
        'KKD Yönetmeliği uyarınca KKD seçimi risk değerlendirmesi sonucuna dayanmalıdır. Önce tehlike belirlenir, sonra risk büyüklüğü hesaplanır (Fine Kinney veya 5x5 matris), risk kabul edilemez seviyedeyse mühendislik/idari kontroller uygulanır, kalan rezidüel risk için KKD önerilir. Seçilen KKD ilgili EN/ISO standardına ve CE işaretlemesine sahip olmalıdır.',
    },
    {
      question: 'KKD kategorileri nelerdir?',
      answer:
        "KKD'ler 6 ana grupta toplanır: 1) Baş koruma (baret — EN 397), 2) Göz/yüz koruma (gözlük, siperlik — EN 166), 3) İşitme koruma (kulak tıkacı, kulaklık — EN 352), 4) Solunum koruma (toz/gaz maskesi — EN 149/EN 14387), 5) El koruma (eldiven — EN 388/EN 374), 6) Ayak koruma (S1-S5 iş ayakkabısı/çizmesi — EN ISO 20345). Düşmeye karşı koruma (paraşüt, can yeleği) ve cilt koruma da eklenebilir.",
    },
    {
      question: "KKD'nin denetimi ne zaman yapılır?",
      answer:
        "KKD'ler her kullanım öncesi çalışan tarafından, periyodik olarak (üretici talimatına göre — örnek: düşme durdurucu sistem TS EN 365 uyarınca en az yılda bir) yetkili kişi tarafından kontrol edilmelidir. Hasarlı, son kullanma tarihi geçmiş veya etkinliği şüpheli KKD'ler kullanım dışı bırakılır. Denetim kayıtları İSG denetimlerinde sunulmak üzere saklanır.",
    },
    {
      question: 'KKD eğitimi zorunlu mu?',
      answer:
        "Evet. 6331 Madde 17 ve KKD Yönetmeliği uyarınca işveren çalışana KKD'nin nasıl kullanılacağı, bakımı, sınırları ve değiştirme zamanı hakkında eğitim vermek zorundadır. Eğitim kayıtları imza karşılığı belgelenir; tekrar eğitim periyodu işyerinin tehlike sınıfına göre belirlenir.",
    },
  ],
  seo: {
    title: 'Kişisel Koruyucu Donanım (KKD) Seçim Yardımcısı — Risk Kriterine Göre EN/ISO Standartları | Riskmatik',
    description:
      '28695 sayılı KKD Yönetmeliği uyumlu kişisel koruyucu donanım seçimi: 58 risk kriteri, 55 KKD ürünü için CE/EN/ISO standart eşleştirme, PDF rapor.',
    keywords:
      'kkd seçim yardımcısı, kişisel koruyucu donanım, ppe seçimi, en iso standart, ce işareti',
    canonicalPath: '/araclar/kkd-secim-yardimcisi',
    featureList: [
      "Risk tipi, yapılan iş ve ortam koşuluna göre 58 kriterden seçim",
      "Seçime göre uygun kişisel koruyucu donanım önerileri",
      "Her öneride ilgili EN/ISO standart numaraları",
      "İstenmeyen önerileri gizleyip geri getirme",
      "Firma adı, tarih ve notlarla mevzuat referanslı PDF rapor",
      "KKD Yönetmeliği ve standartlar rehber içeriği",
      "Ücretsiz, kayıt gerektirmez",
    ],
    lastmod: '2026-10-18',
    priority: '0.8',
    changefreq: 'monthly',
  },
  order: 60,
  enabled: true,
  launchedAt: '2025-08-01',
  topics: ['kkd', 'koruyucu-donanim', 'kisisel-koruyucu', 'baret', 'kask', 'gozluk', 'maske', 'eldiven', 'ayakkabi', 'kulaklik', 'en-397', 'en-388', 'en-iso-20345', 'en-166', 'en-352', 'en-149'],
  intent: 'rehber',
  spamCapacity: 4,
  bridge: {
    href: '/ai-destekli-risk-analizi',
    etiket: 'Risk analizinde KKD\'nin otomatik önerildiği sistemi görün',
  },
};

export default manifest;
